import React from "react";
interface Props {
  message: string;
  payments: string;
  perMonth: string;
  openApplyModal: () => void;
}
const CreditKeyMessage = ({
  message,
  payments,
  perMonth,
  openApplyModal
}: Props) => {
  return <button type="button" onClick={openApplyModal} className="flex items-start mt-3 mb-2 justify-between border-0 bg-transparent p-0 w-full" data-sentry-component="CreditKeyMessage" data-sentry-source-file="CreditKeyMessage.tsx">
      <span data-testid="credit-key-payment-message" className="flex flex-wrap items-center text-xs leading-tight text-gray-800">
        {message}&nbsp;
        <span data-testid="credit-key-payment-amount" className="font-bold">
          {payments}
        </span>
        {perMonth}&nbsp;
        <span className="flex items-center font-semibold text-xs p-0 text-green-600 hover:text-green-800 hover:underline">
          Apply Now
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-sentry-element="svg" data-sentry-source-file="CreditKeyMessage.tsx">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="CreditKeyMessage.tsx" />
          </svg>
        </span>
      </span>
      <span className="flex items-center">
        <img className="px-1 py-1/2 bg-gray-50 hover:bg-gray-200 rounded" src="//cdnimg.webstaurantstore.com/uploads/design/2023/3/credit-key-logo.svg" alt="" />
      </span>
    </button>;
};
export default CreditKeyMessage;